"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldGroup = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../../utility/distillUtilityClasses"));
exports.FieldGroup = function (props) {
    var inline = props.inline, tight = props.tight, nowrap = props.nowrap, fill = props.fill, equal = props.equal, _a = props.component, Component = _a === void 0 ? "div" : _a, className = props.className, utilityAndDivProps = __rest(props, ["inline", "tight", "nowrap", "fill", "equal", "component", "className"]);
    var _b = distillUtilityClasses_1.default(utilityAndDivProps), utilityClasses = _b[0], divProps = _b[1];
    var classes = __spreadArrays([
        "c-field-group",
        inline ? "+inline" : "",
        tight ? "+tight" : "",
        nowrap ? "+nowrap" : "",
        fill ? "+fill" : "",
        equal ? "+equal" : ""
    ], utilityClasses, [
        className,
    ]).filter(function (item) { return !!item; });
    return react_1.default.createElement(Component, __assign({ className: classes.join(" ") }, divProps));
};
//# sourceMappingURL=FieldGroup.js.map